<template>
  <div id="app">
    <div class="hero is-primary">
      <nav class="navbar">
        <div class="container">
          <div class="navbar-brand">
            <a class="navbar-item" href="../">
              <img src="./assets/images/reguity-logo-white.png" alt="Logo">
              <span class="sublogo">Shares subscription forms</span>
            </a>
            <span class="navbar-burger burger" data-target="navbarMenu">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </div>
        </div>
      </nav>
    </div>
    <div id="view">
      <router-view/>
    </div>
    <reguity-footer />
  </div>
</template>

<script>
import ReguityFooter from '@/components/ReguityFooter.vue'
export default {
  name: 'app',
  data: () => ({}),
  mounted: function() {},
  methods: {},
  components: {
    ReguityFooter
  }
}
</script>

<style lang="scss">
#app {
  font-family: Montserrat;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  letter-spacing: -0.5px;
  font-size: 16px;
  line-height: 26px;
  font-weight: 400;
}
#view {
  min-height: calc(100vh - 96px);
}
.sublogo {
  font-family: Poppins;
  margin-left: 10px;
  margin-top: -3px;
}
</style>
